import styled from 'styled-components';

const Header = styled.header`
	background-color: ${p => p.theme.colors.bgrdGrey};
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 109px;
	padding: 0 50px;
	border: 1px solid #ccd2d9;

	@media (max-width: 768px) {
		height: 71px;
		padding: 0 19px;
	}
`;

const Logo = styled.img`
	height: 55px;
	@media (max-width: 768px) {
		width: 108px;
		height: 40px;
	}
`;

const LeftContent = styled.div`
	flex: 1;
	display: flex;
`;

const MiddleContent = styled.ul`
	flex: 1;
	display: flex;
	justify-content: space-between;

	@media (max-width: 768px) {
		display: none;
	}
`;

const RightContent = styled.ul`
	flex: 1;
	display: flex;
	justify-content: flex-end;

	@media (max-width: 768px) {
		display: none;
	}
`;

const Button = styled.button`
	background-color: ${p => p.theme.colors.black};
	width: 164px;
	height: 53px;
	border-radius: 0;
	border-width: 0;
`;

const exportedObject = {
	Header,
	Logo,
	LeftContent,
	MiddleContent,
	RightContent,
	Button,
};

export default exportedObject;
